import { render, staticRenderFns } from "./AddAdminPopup.vue?vue&type=template&id=62930ed2&scoped=true"
import script from "./AddAdminPopup.vue?vue&type=script&lang=js"
export * from "./AddAdminPopup.vue?vue&type=script&lang=js"
import style0 from "./AddAdminPopup.vue?vue&type=style&index=0&id=62930ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62930ed2",
  null
  
)

export default component.exports